export default [
    {
        path: '/(uk/|ru/)?/banner/index',
        name: 'BannerTable',
        component: () => import('../views/banner/BannerTable'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title:'Баннера'
        },
    }, {
        path: '/(uk/|ru/)?/banner/detail',
        name: 'BannerCreate',
        component: () => import('../views/banner/BannerCreate'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Создание нового банера'
        },
    }, {
        path: '',
        component: () => import('../views/antifraud/AntifraudList'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-cancel',
            title: 'Антифрод',
            altNavSubMenuActive: '/anti-fraud/index'
        },
        children: [
            {
                path: '/(uk/|ru/)?/anti-fraud/index',
                name: 'new',
                component: () => import('../views/antifraud/tables/new'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод'
                },
            }, {
                path: '/(uk/|ru/)?/anti-fraud/verify',
                name: 'verify',
                component: () => import('../views/antifraud/tables/verify'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод',
                },
            }, {
                path: '/(uk/|ru/)?/anti-fraud/blocked',
                name: 'blocked',
                component: () => import('../views/antifraud/tables/blocked'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод'
                },
            }, {
                path: '/(uk/|ru/)?/anti-fraud/black-list',
                name: 'BlackList',
                component: () => import('../views/antifraud/tables/BlackList'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод'
                },
            }, {
                path: '/(uk/|ru/)?/anti-fraud/exeption-drivers',
                name: 'ExiptionDrivers',
                component: () => import('../views/antifraud/tables/ExiptionDrivers'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Антифрод'
                },
            }, {
                path: '/(uk/|ru/)?/payout/anti-fraud-orders',
                name: 'antifraudorders',
                component: () => import('../views/antifraud/tables/Antifraudorders'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Сводный отчет проблемных заказов'
                },
            }, {
                path: '/(uk/|ru/)?/payout/held-orders',
                name: 'heldorders',
                component: () => import('../views/antifraud/tables/Heldorders'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Удержанные заказы',
                    type: 'opened'
                },
            }, {
                path: '/(uk/|ru/)?/payout/held-orders/closed',
                name: 'heldordersclosed',
                component: () => import('../views/antifraud/tables/Heldorders'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-cancel',
                    title: 'Удержанные заказы',
                    type: 'closed'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/anti-fraud/security',
        component: () => import('../views/antifraud/Security'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-cancel',
            title: 'Антифрод Глобальная настройка'
        }
    }, {
        path: '/(uk/|ru/)?/anti-fraud/devices',
        component: () => import('../views/antifraud/Device'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-cancel',
            title: 'Идентификаторы устройств'
        }
    },
]
